export let requestReasonForJoining = () => {
  const webinarReason = $('#webinar-reason');
  const reason = webinarReason.data('informedReason');
  if (!reason){
    webinarReason.modal({
      backdrop: 'static',
      keyboard: false
    },'toggle');
  }

  $('#reason_update').on('ajax:success', function(event) {
    const xhr = event.detail[2];
    $('#reason-body').html(xhr.responseText);
  });
};
